import React from 'react'
import { Redirect } from 'react-static'

import AdminContentPeople from './AdminContentPeople'
import AdminContentListen from './AdminContentListen'
import Loading from '../common/Loading'

export default class AdminContent extends React.Component {
  constructor(props) {
    super(props)
    this.state = { data: props.data }
    this.showContent = this.showContent.bind(this)
  }
  componentWillReceiveProps(next) {
    if (next.data !== this.props.data) {
      this.setState({ data: next.data })
    }
  }
  showContent(data) {
    const { current, remove, edit } = this.props
    switch (current) {
      case 'people':
        return (
          <div>
            <h3 className="title is-3">People</h3>
            {data.map((person, i) => (
              <AdminContentPeople edit={edit} person={person} key={i} />
            ))}
          </div>
        )
        break
      case 'listen':
        return (
          <div>
            <h3 className="title is-3">Listen</h3>
            {data.map((link, i) => (
              <AdminContentListen
                data={data}
                totalLinks={data.length}
                remove={remove}
                edit={edit}
                link={link}
                key={i}
              />
            ))}
          </div>
        )
        break
      default:
        return <Redirect to={{ pathname: '/admin/slideshow' }} />
    }
  }
  render() {
    const { data } = this.state
    return (
      <ul className="admin-content">
        {data !== null ? this.showContent(data) : <Loading color="#ff486a" percentHeight={20} />}
      </ul>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/admin/AdminContent.js